<template>
  <v-app>
    <head>
      <title>
        Edit Your Profile - Foraje
      </title>
      <meta name="description" content="Edit your Foraje personal Profile Page">
    </head>

    <v-container v-if="isuserdataloading">
      <v-row  >
        <v-col cols="12" class="text-center">
          <v-progress-circular
            :size="100"
            :width="7"
            color="primary"
            indeterminate
          />
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else>
      <v-card>
        <v-row>
          <v-col cols="12" sm="4" lg="3" class="py-0">
            <v-img
              :src="user.profile_image.image.medium_square_crop"
              :lazy-src="user.profile_image.image.small_square_crop"
              class="elevation-1 ProfilePicture"
              v-if="user.profile_image && user.profile_image.image"
            >
            </v-img>
            <v-img v-else src="https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg" class="ProfilePicture elevation-1">
            </v-img>
          </v-col>
          <v-col cols="12" sm="8" lg="9" class="pa-6 pa-sm-2">
            <v-row>
              <v-col cols="auto" >
                <h1> <span v-if="user && user.display_name">{{user.display_name}} </span>
                  <span v-else>{{user.name}}</span></h1>
              </v-col>
              <v-col cols="12">
                <span style="display: inline-block"><v-icon>mdi-map-marker</v-icon>{{user.location}}</span>
              </v-col>
              <v-col cols="12" v-if="user.description && user.description.length<255" class="pr-5">
                <p>{{user.description}}</p>

              </v-col>
              <v-col cols="12" v-else>
                <p>{{user.description}}</p>
              </v-col>
            </v-row>

          </v-col>
          <v-col cols="12" sm="4" lg="3">
          <v-dialog v-model="change_picture_dialog" max-width="500px">
            <template v-slot:activator="{ on }">
              <v-btn
                color="primary"
                dark
                v-on="on"
                text

              >
                Change Your Profile Picture
              </v-btn>
            </template>
            <v-card>
              <form @submit.prevent="UserProfileImageUpload">
              <v-card-title>
                <span class="headline">Upload a profile picture</span>
              </v-card-title>
              <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-file-input
                    label="Profile Picture"
                    hint="A picture for your profile!"
                    prepend-icon="mdi-camera"
                    v-model="profile_image"
                    accept="image/*"
                    required
                  >
                    <template v-slot:selection="{ text }">
                      <v-chip
                        small
                        label
                        color="primary"
                      >
                        {{ text }}
                      </v-chip>
                    </template>
                  </v-file-input>
                </v-col>
              </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer/>
                <v-btn type="submit" :loading="image_submit_loading" color="primary">Submit</v-btn>
              </v-card-actions>
              </form>
            </v-card>
          </v-dialog>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
    <v-container v-if="!isuserdataloading">
      <form @submit.prevent="UserProfileUpdate">
      <v-card>
        <v-row>
          <v-col cols="12">
            <v-card-text>
            <v-text-field
              name="name"
              label="Your name"
              id="name"
              hint="Your name. Only for internal use, won't be displayed."
              required
              v-model="user.name"
              :disabled="profile_edit_loading"
            />
            <v-text-field
              name="displayname"
              label="Display Name"
              id="displayname"
              hint="The name you would like displayed on your profile page"
              required
              v-model="user.display_name"
              :disabled="profile_edit_loading"
            />
            <v-text-field
              name="location"
              label="Location"
              id="location"
              hint="Where in the world are you?"
              required
              v-model="user.location"
              :disabled="profile_edit_loading"
            />
            <v-textarea
              name="description"
              label="Bio"
              id="decription"
              hint="Tell us about yourself!"
              required
              v-model="user.description"
              :disabled="profile_edit_loading"
            />
            </v-card-text>
<v-card-actions>
  <v-spacer/>
  <v-btn>Cancel</v-btn>
  <v-btn color="primary" :loading="profile_edit_loading" type="submit">Submit

  <span slot="loader" class="custom-loader">
                        <v-progress-circular indeterminate color="green"/>
                       </span>
</v-btn>
  <v-spacer/>
</v-card-actions>
          </v-col>
        </v-row>
      </v-card>
      </form>
    </v-container>


  </v-app>
</template>

<script>
import axios from 'axios';

export default {
  name: 'EditProfile',
  data: () => ({

    user: [],
    errors: [],
    change_picture_dialog: false,
    isuserdataloading: false,
    profile_image: null,
    image_submit_loading: false,
    profile_edit_loading: false,
  }),
  methods: {
    GetUserData() {
      const authheader = `Token ${this.$store.getters.token}`;
      this.isuserdataloading = true;
      const userSlug = this.$store.getters['user/user_slug'];
      axios.get('profile/edit/', {
        headers: {
          Authorization: authheader,
        },
      })
        .then((response) => {
          this.user = response.data;
        })
        .catch((e) => {
          this.errors.push(e);
        });
      axios.get(`filtered/baseproduct/by/producer/${userSlug}/`)
        .then((response) => {
          this.crops = response.data.results;
        })
        .catch((e) => {
          this.errors.push(e);
        });
      axios.get(`filtered/products/by/vendor/${userSlug}/`)
        .then((response) => {
          this.products = response.data.results;
          this.isuserdataloading = false;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    UserProfileImageUpload() {
      this.image_submit_loading = true;
      const authheader = `Token ${this.$store.getters.token}`;
      const formData = new FormData();
      formData.append('image', this.profile_image, this.profile_image.name);
      return axios.post('image/profile/create/', formData,
        {
          headers: {
            Authorization: authheader,
          },
        })
        .then((response) => {
          this.user.profile_image.image = response.data.image;
          this.$parent.$emit('alert-emitted', {
            alert_icon: 'mdi-check-circle', alert_color: 'success', alert_message: `Product Image " ${this.profile_image.name} "  successfully uploaded!`, alert_model: true,
          });
          this.image_submit_loading = false;
          this.change_picture_dialog = false;
        })
        .catch(() => {
          this.$parent.$emit('alert-emitted', {
            alert_icon: 'mdi-emoticon-frown-outline', alert_color: 'error', alert_message: 'Something broke with the image upload. Sorry :( ', alert_model: true,
          });
        });
    },
    UserProfileUpdate() {
      this.profile_edit_loading = true;
      const authheader = `Token ${this.$store.getters.token}`;
      axios.patch('profile/edit/', {
        name: this.user.name,
        display_name: this.user.display_name,
        location: this.user.location,
        description: this.user.description,
      }, {
        headers: {
          Authorization: authheader,
        },
      })
        .then(() => {
          this.$router.push(`/profiles/${this.user.slug}`);
        })
        .then(() => {
          this.profile_edit_loading = false;
        });
    },
  },
  // Fetches variety info when the component is created.
  created() {
    this.GetUserData();
  },
  mounted() {
  },
  computed: {
    currentUser() {
      return this.$store.getters.user;
    },
  },
};
</script>

<style scoped>


  .FetchedThumbail{
    border-radius: 50%;
  }
  .ProfilePicture{
    border-radius: 50%;
  }
  .ProfilePictureBackground{

  }
  .ProfilePage{
    background: linear-gradient(#2d796b, #468a7e 10%, #8dbbb3 38%, #add1cb 48%, #eaf1f0 62%)
    repeat scroll;
  }


</style>
